module.exports = __webpack_public_path__ + "static/media/recipedrink.710d18b2.gif";